import { Compliance } from '../enum/compliance.enum';

export function getComplianceLabel(compliance: Compliance): string {
  switch (compliance) {
    case Compliance.Compliant:
      return 'Compliant';
    case Compliance.NonCompliant:
      return 'Non-Compliant';
    case Compliance.NonEligible:
      return 'Non-Qualifying';
    default:
      return '';
  }
}
